export enum OptionComboboxCdSelect {
  // AlertTypes
  AlertType_Siniestros = 'CB_SUB-AREA_SI',
}

export enum OptionComboboxCdOption {
  // Subareas
  Subarea_Siniestros = 'CB_SUB-AREA-COB_SIN',
  // AlertTypes
  // Alerta automatica variables graves
  AlertType_AlertaAutomaticaVariablesGraves = 'CB_TIPO-ALERTA_AAVG',
}
